// removed by extract-text-webpack-plugin
module.exports = {"RateCard":"styles__RateCard___dQsBI","RateCardTitle":"styles__RateCardTitle___3JFw0","RateCardInclude":"styles__RateCardInclude___15KR9","RateCardList":"styles__RateCardList___13Tmz","RateCardPrice":"styles__RateCardPrice___2dmZa","Discount":"styles__Discount___cuqTP","AltPrice":"styles__AltPrice___2IZWv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Rates/RateCard/styles.scss
// module id = 1488
// module chunks = 0